import { API_ENDPOINTS } from "../config/api";
import { apiRequest } from "./httpClient";

export const applyToVacancy = async (vacancyId, data, token) => {
  if (!API_ENDPOINTS?.JOB_APPLICATIONS) {
    throw new Error("Endpoint de candidaturas não configurado");
  }

  return apiRequest(`${API_ENDPOINTS.JOB_APPLICATIONS}/${vacancyId}/apply`, {
    method: "POST",
    body: data,
    token,
    fallbackMessage: "Erro ao aplicar para a vaga",
    errorCode: "APPLICATION_SUBMIT_FAILED",
  });
};

export const getApplicationsByCandidate = async (
  candidateId,
  { page, size },
  token
) => {
  if (!API_ENDPOINTS?.CANDIDATES) {
    throw new Error("Endpoint de candidatos não configurado");
  }

  // Cria a URL com os parâmetros de query
  const url = new URL(
    `${API_ENDPOINTS.CANDIDATES}/${candidateId}/applications`
  );
  url.searchParams.append("page", page);
  url.searchParams.append("size", size);

  return apiRequest(url, {
    method: "GET",
    token,
    fallbackMessage: "Erro ao buscar candidaturas",
    errorCode: "APPLICATION_LIST_FAILED",
  });
};
